import templateUrl from './process-terminations.component.html';
import { TerminationVM } from './employment-processing-models';
import { EventEmitter } from '../../common/components/event-emitter';

export const ProcessTerminationsComponent = {
    templateUrl,
    controller: class ProcessTerminationsComponent {
        fileName: string;
        employees: TerminationVM[];
        handleCancel: EventEmitter<any>;
        handleFinish: EventEmitter<any>;
        pageNumber = 1;
        pageSize = 10;

        selectionCount() {
            return this.employees.reduce(function (count, number) {
                return count + (number.isSelected ? 1 : 0);
            }, 0);
        }
    },
    controllerAs: "vm",
    bindings: {
        fileName: "<",
        employees: "<",
        handleCancel: "&",
        handleFinish: "&"
    }
};
